// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UAMachineryOperationCounter
 */
export interface UAMachineryOperationCounter {
    /**
     * OperationCycleCounter is counting the times the
     * component switches from not performing an
     * activity to performing an activity. For example,
     * each time a valve starts moving, is counted. This
     * value shall only increase during the lifetime of
     * the component and shall not be reset when the
     * component is restarted.
     */
    operationCycleCounter?: number;
    /**
     * OperationDuration is the duration the
     * MachineryItem has been powered and performing an
     * activity. This counter is intended for machines
     * and components where a distinction is made
     * between switched on and in operation. For
     * example, a drive might be powered on but not
     * operating. It is not intended for machines or
     * components always performing an activity like
     * sensors always measuring data. This value shall
     * only increase during the lifetime of the
     * MachineryItem and shall not be reset when it is
     * restarted. The OperationDuration is provided as
     * Duration, i.e., in milliseconds or even fractions
     * of a millisecond. However, the Server is not
     * expected to update the value in such a high
     * frequency, but maybe once a minute or once an
     * hour, depending on the application.
     */
    operationDuration?: number;
    /**
     * PowerOnDuration is the duration the MachineryItem
     * has been powered. The main purpose is to
     * determine the time in which degradation of the
     * MachineryItem occurred. The details, when the
     * time is counted, is implementation-specific.
     * Companion specifications might define specific
     * rules. Typically, when the MachineryItem has
     * supply voltage and the main CPU is running, the
     * time is counted. This may include any kind of
     * sleep mode, but may not include pure Wake on LAN.
     * This value shall only increase during the
     * lifetime of the MachineryItem and shall not be
     * reset when it is restarted. The PowerOnDuration
     * is provided as Duration, i.e., in milliseconds or
     * even fractions of a millisecond. However, the
     * Server is not expected to update the value in
     * such a high frequency, but maybe once a minute or
     * once an hour, depending on the application.
     */
    powerOnDuration?: number;
}

/**
 * Check if a given object implements the UAMachineryOperationCounter interface.
 */
export function instanceOfUAMachineryOperationCounter(value: object): value is UAMachineryOperationCounter {
    return true;
}

export function UAMachineryOperationCounterFromJSON(json: any): UAMachineryOperationCounter {
    return UAMachineryOperationCounterFromJSONTyped(json, false);
}

export function UAMachineryOperationCounterFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAMachineryOperationCounter {
    if (json == null) {
        return json;
    }
    return {
        
        'operationCycleCounter': json['operationCycleCounter'] == null ? undefined : json['operationCycleCounter'],
        'operationDuration': json['operationDuration'] == null ? undefined : json['operationDuration'],
        'powerOnDuration': json['powerOnDuration'] == null ? undefined : json['powerOnDuration'],
    };
}

export function UAMachineryOperationCounterToJSON(json: any): UAMachineryOperationCounter {
    return UAMachineryOperationCounterToJSONTyped(json, false);
}

export function UAMachineryOperationCounterToJSONTyped(value?: UAMachineryOperationCounter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operationCycleCounter': value['operationCycleCounter'],
        'operationDuration': value['operationDuration'],
        'powerOnDuration': value['powerOnDuration'],
    };
}

